export const storeProducts = [
  {
    id: 1,
    title: "Spokky Gown - Black",
    img: "img/gown-black.png",
    price: 30,
    company: "SPOKKY WEARS",
    info: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid saepe libero magnam nulla aspernatur dolorum harum id, tenetur, ab laudantium culpa? Ab voluptatum delectus aut reiciendis quod explicabo dolorem aliquid doloremque est minima, accusantium corrupti velit cupiditate itaque quam cum sint consequatur maiores vero, dolorum aperiam amet nihil. Accusamus saepe, repellat distinctio provident minus assumenda error sapiente. Exercitationem, est voluptates!",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 2,
    title: "Crochet - White",
    img: "img/indoor-top.png",
    price: 40,
    company: "WEARSHINTON",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure quis voluptate dolorum rem dolores enim ipsa voluptatibus a aliquid optio exercitationem, in quo molestias eum fuga adipisci doloremque ea minima magni! Fugit quae, omnis laborum iure repellat officiis animi quaerat qui iusto excepturi inventore similique cum atque. Voluptatem aliquam numquam quam illo, voluptates et commodi! Aspernatur magni distinctio optio, delectus error assumenda similique illum explicabo.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 3,
    title: "Yahweh - Black",
    img: "img/shirt-black.png",
    price: 25,
    company: "FIFTYSHADES",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure quis voluptate dolorum rem dolores enim ipsa voluptatibus a aliquid optio exercitationem, in quo molestias eum fuga adipisci doloremque ea minima magni! Fugit quae, omnis laborum iure repellat officiis animi quaerat qui iusto excepturi inventore similique cum atque. Voluptatem aliquam numquam quam illo, voluptates et commodi! Aspernatur magni distinctio optio, delectus error assumenda similique illum explicabo.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 4,
    title: "Sport Canvas - Orange",
    img: "img/shoe-nike.png",
    price: 70,
    company: "NIKE",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores voluptatem, earum delectus, accusantium dolorem minus eligendi exercitationem ab, velit aliquid iure. Voluptatem veritatis ipsam excepturi, vitae ad, illo quo ex explicabo inventore saepe laboriosam commodi sequi obcaecati hic accusantium voluptatum nulla nostrum iste perspiciatis corrupti rerum labore repudiandae doloribus. Accusamus aliquid porro dolor, laborum atque fuga error magni iusto natus esse quo recusandae numquam hic.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 5,
    title: "Nike Fashion - Black",
    img: "img/shoe-black.png",
    price: 60,
    company: "NIKE",
    info: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aliquid saepe libero magnam nulla aspernatur dolorum harum id, tenetur, ab laudantium culpa? Ab voluptatum delectus aut reiciendis quod explicabo dolorem aliquid doloremque est minima, accusantium corrupti velit cupiditate itaque quam cum sint consequatur maiores vero, dolorum aperiam amet nihil. Accusamus saepe, repellat distinctio provident minus assumenda error sapiente. Exercitationem, est voluptates!",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 6,
    title: "Spokky Gown - Black",
    img: "img/gown.png",
    price: 92,
    company: "SPOKKY WEARS",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure quis voluptate dolorum rem dolores enim ipsa voluptatibus a aliquid optio exercitationem, in quo molestias eum fuga adipisci doloremque ea minima magni! Fugit quae, omnis laborum iure repellat officiis animi quaerat qui iusto excepturi inventore similique cum atque. Voluptatem aliquam numquam quam illo, voluptates et commodi! Aspernatur magni distinctio optio, delectus error assumenda similique illum explicabo.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 7,
    title: "Kiikh - Solarized White",
    img: "img/shirt.png",
    price: 88,
    company: "ORIGINALS",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure quis voluptate dolorum rem dolores enim ipsa voluptatibus a aliquid optio exercitationem, in quo molestias eum fuga adipisci doloremque ea minima magni! Fugit quae, omnis laborum iure repellat officiis animi quaerat qui iusto excepturi inventore similique cum atque. Voluptatem aliquam numquam quam illo, voluptates et commodi! Aspernatur magni distinctio optio, delectus error assumenda similique illum explicabo.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 8,
    title: "Canvas - Red",
    img: "img/shoe-red.png",
    price: 67.5,
    company: "D & G",
    info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores voluptatem, earum delectus, accusantium dolorem minus eligendi exercitationem ab, velit aliquid iure. Voluptatem veritatis ipsam excepturi, vitae ad, illo quo ex explicabo inventore saepe laboriosam commodi sequi obcaecati hic accusantium voluptatum nulla nostrum iste perspiciatis corrupti rerum labore repudiandae doloribus. Accusamus aliquid porro dolor, laborum atque fuga error magni iusto natus esse quo recusandae numquam hic.",
    inCart: false,
    count: 0,
    total: 0,
  },
];

export const detailProduct = {
  id: 1,
  title: "Canvas - Red",
  img: "img/shoe-red.png",
  price: 67.5,
  company: "D & G",
  info: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores voluptatem, earum delectus, accusantium dolorem minus eligendi exercitationem ab, velit aliquid iure. Voluptatem veritatis ipsam excepturi, vitae ad, illo quo ex explicabo inventore saepe laboriosam commodi sequi obcaecati hic accusantium voluptatum nulla nostrum iste perspiciatis corrupti rerum labore repudiandae doloribus. Accusamus aliquid porro dolor, laborum atque fuga error magni iusto natus esse quo recusandae numquam hic.",
  inCart: false,
  count: 0,
  total: 0,
};
